export default __webpack_public_path__ + "eff3935bafc603a465929d2e77d9c255.svg";